var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        _vm.liquidItems.length && _vm.liquidItems.length < 2
          ? "site-section site-section--no-padding-bot"
          : "site-section"
    },
    [
      _c("div", { staticClass: "site-row" }, [
        _c("div", { staticClass: "liquids-items__filter" }, [
          _vm.liquids.length > 0
            ? _c(
                "div",
                { staticClass: "filter-section filter-section--no-padding" },
                [
                  _c("div", { staticClass: "filter-items" }, [
                    _vm.liquids.length > 0
                      ? _c(
                          "div",
                          { staticClass: "filter-item filter-item--mw" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "sr-only",
                                attrs: { for: "liquidsFilter" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.dictionaries.LiquidOptionDefault)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.liquid,
                                    expression: "liquid"
                                  }
                                ],
                                staticClass: "filter-item__select",
                                attrs: {
                                  id: "liquidsFilter",
                                  name: "liquidsFilter",
                                  disabled: _vm.isLoading
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.liquid = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.filterChanged
                                  ]
                                }
                              },
                              [
                                _c("option", { attrs: { value: "All" } }, [
                                  _vm._v(
                                    _vm._s(_vm.dictionaries.LiquidOptionDefault)
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.liquids, function(liquid, index) {
                                  return liquid.Name
                                    ? _c(
                                        "option",
                                        { domProps: { value: liquid.Key } },
                                        [_vm._v(_vm._s(liquid.Name))]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.liquidItems.length || _vm.liquidItems.length > 1,
              expression: "!liquidItems.length || liquidItems.length > 1"
            }
          ],
          staticClass: "site-row"
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.liquidItems.length && _vm.liquidItems.length < 2,
              expression: "liquidItems.length && liquidItems.length < 2"
            }
          ],
          staticClass: "liquids-section"
        },
        [
          _c("div", { staticClass: "liquids-items" }, [
            _c(
              "div",
              { staticClass: "liquids-items__inner site-row" },
              _vm._l(_vm.liquidItems, function(liquidItem) {
                return _c("liquidItem", {
                  key: liquidItem.Id,
                  attrs: {
                    liquidItem: liquidItem,
                    dictionaries: _vm.dictionaries,
                    products: liquidItem.Products
                  }
                })
              }),
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "separator-item" }, [
      _c("hr", { staticClass: "separator-item__hr" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c03e5f7", { render: render, staticRenderFns: staticRenderFns })
  }
}